/***
*
*   BILLING
*   Change subscription, update card details or view past invoices
*
**********/

import React, { Fragment, useState, useContext } from 'react';

// Components import.
import { AuthContext, AccountNav, Message, Animate, useAPI, usePlans, useCan, } from 'components/lib';
import { BillingInvoices } from './invoices';
// Assets import.
const Messages = require('./messages.json');

export function Billing(props) {

    // state/context
    const context = useContext(AuthContext);
    const permissionOrg = useCan('account.orgbilling.view')
    const permissionScholar = useCan('account.billing.scholar.view')
    // fetch subscription
    const subscription = useAPI(`/api/account/subscription?plan=${context?.user?.plan}`);

    return (
        <Fragment>

            <AccountNav />
            <Animate>
                {!subscription?.loading &&
                    (permissionOrg && !(context?.user?.plan === 'free' || context?.user.plan === 'hybrid') && subscription?.data?.status !== 'active' && subscription?.data?.status !== 'trialing') && 
                    <Message
                        title={subscription?.data?.status === 'expiring_soon' ? props.t('account.billing.message.expiringTitle') : props.t('account.billing.message.title')}
                        type={subscription?.data?.status === 'expiring_soon' ? 'warning' : 'error'}
                        text={context.user?.subscription ? props.t(`account.billing.message.${context.user?.subscription}.text`) : props.t('account.billing.message.past_due.text')}
                        buttonText={(!(context?.user?.plan === 'free' || context?.user.plan === 'hybrid') && permissionScholar) ? "Complete Payment" : props.t(`account.billing.message.${context.user?.subscription}.buttonText`)} 
                        buttonLink={(!(context?.user?.plan === 'free' || context?.user.plan === 'hybrid') && permissionScholar) ? subscription?.data?.object?.payment_link : Messages[context.user?.subscription]?.buttonLink} 
                    />
                }
                <BillingInvoices />
            </Animate>
        </Fragment>
    );
}